var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loadingPage',{attrs:{"show":_vm.loading}}),(!_vm.loading)?_c('v-card',{class:`main-card d-flex `,attrs:{"color":_vm.cardColor,"elevation":_vm.elevation == null ? 3 : _vm.elevation}},[_c('v-card-text',{class:`main-card--card-text ${_vm.classCard}`},[_vm._t("cardContent")],2)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }